import {
  GET_ALL_NEWS_REQUEST,
  GET_ALL_NEWS_SUCCESS,
  GET_ALL_NEWS_FAILURE,
} from "./actionTypes";

const initialState = {
  ISLOADING: false, // Fixed typo (was "ISlOADING")
  ALL_NEWS_LIST: [], 
  ISFAILURE: false,
};

export  function ALL_NEWS_LISTreducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_ALL_NEWS_REQUEST:
      return { ...state, ISLOADING: true }; // Fixed typo
    case GET_ALL_NEWS_SUCCESS:
      return {
        ...state,
        ALL_NEWS_LIST: payload.records, // Updated key to match news-related data
        ISLOADING: false,
      };
    case GET_ALL_NEWS_FAILURE:
      return { ...state, ISFAILURE: true, ISLOADING: false };
    default:
      return state;
  }
}
